import { Stats } from "../../../state/types";
import { StatScores } from "./StatScores";

// # Totale leefbaarheidscore == "absolute beoordeling" (denk aan cijfer)
// # 0,15 lijkt het SD. Dus -2,25 en 2,25 zijn maxima

// TODO Check deze waarden, zelf bedacht

const legend = [
  { low: -0.25, name: "Slecht", color: "#CF783F" },
  { low: -0.15, name: "Ruim onvoldoende", color: "#D7995E" },
  { low: -0.1, name: "Onvoldoende", color: "#E0B881" },
  {
    low: -0.05,
    name: "Zwak",
    color: "#FBF2C4",
  },
  { low: 0, name: "Voldoende", color: "#D0D2A6" },
  {
    low: 0.05,
    name: "Ruim voldoende",
    color: "#A7B38A",
  },
  { low: 0.1, name: "Goed", color: "#819470" },
  {
    low: 0.15,
    name: "Zeer goed",
    color: "#5E7658",
  },
  { low: 0.25, name: "Uitstekend", color: "#3C5941" },
];

const mapping = {
  fysieke_leefomgeving: "Fysieke leefomgeving",
  overlast_onveiligheid: "Overlast en onveiligheid",
  sociale_samenhang: "Sociale samenhang",
  voorzieningen: "Voorzieningen",
  woningvoorraad: "Woningvoorraad",
};
export const Livability = ({ stats }: { stats: Stats }) => {
  /*
  score: 0.18029363,
  fysieke_leefomgeving: 0.023607545,
  overlast_onveiligheid: 0.10741752,
  sociale_samenhang: 0.10470119,
  voorzieningen: -0.13426615,
  woningvoorraad: 0.078833535,
   */
  return <StatScores stats={stats} mapping={mapping} title="Leefbaarheid totaal" legend={legend} />;
};
